
const TariffCard = ({ price, duration, style }) => (
    <div className="tariff-card" style={ style}>
        <h3>{price}</h3>
        <p>{duration}</p>
    </div>
);

export default TariffCard;